<script lang="ts">
  import { MarkallasIncomplete, Markallasfinished } from "../../../utils/Constant/Constant";
  import {todoAllmark} from "../../../store"
  import { toasts } from 'svelte-toasts';
  let setTodoAllmark:boolean
  todoAllmark.subscribe((value)=>{
    setTodoAllmark = value
  })
  const handleMark = () => {
      todoAllmark.update(value => value = true)
      toasts.success({
          description: 'All Task Completed !',
          placement: 'top-right',
      });
  }
  const handleMarkRemove =() => {
      todoAllmark.update(value => value = false )
      toasts.error({
          description: 'All Task In-Completed !',
          placement: 'top-right',
      });
  }

</script>
<div class="todo-list-container">
  <div class="mark-all-tasks">
    <!-- svelte-ignore a11y-click-events-have-key-events -->
    <div class="mark-all-tasks-container">
      {#if setTodoAllmark === false}
        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <span class="mark-all-btn" id="mark-all-finished" role="button" on:click={handleMark}>
            <span class="btn-label">{Markallasfinished}</span>
            <span class="action-box completed">
                <i class="icon"><i class="icon-check"></i></i>
            </span>
        </span>
      {:else}
        <span class="mark-all-btn move-down" id="mark-all-incomplete" role="button" on:click={handleMarkRemove}>
            <span class="btn-label">{MarkallasIncomplete}</span>
            <span class="action-box">
                <i class="icon"><i class="icon-check"></i></i>
            </span>
        </span>
      {/if}
    </div>
  </div>
</div>